/*
This source is part of the Akeria  and is
copyrighted by Uniphore system software limited.

All rights reserved.  No part of this work may be reproduced, stored in a
retrieval system, adopted or transmitted in any form or by any means,
electronic, mechanical, photographic, graphic, optic recording or otherwise,
translated in any language or computer language, without the prior written
permission of  Uniphore system software limited.

Uniphore system software limited.
Vaishnavi Silicon Terrace, B- Block, 
3rd & 4th floor, Hosur Rd, 
Adugodi, Bengaluru, Karnataka 560095

India

Copyright 2019 Uniphore system software limited.

Modification History

Date          Version                    Author                        Description
----------   -----------          --------------- ----------------     ------------------------
01 07 2018  1                     Professional service Initial version     
28-11-2019  1.1            Gokulakannan                         Adding for more option menu using the popover functionalites

20-11-2019   1.2        Adhrish choudhary               chnanged the UI/UX of the form 

*/



import { Component, OnInit } from '@angular/core';
import { CommonDeclarationService } from '../service/common/common-declaration.service';
import { CommonDefinitionService } from '../service/common/common-definition.service';
import { Platform, NavController } from '@ionic/angular';
import { ActionlistenService } from '../service/actionlisten.service';
import { RestapiService } from '../service/api/restapi.service';

@Component({
  selector: 'app-popover',
  templateUrl: './popover.component.html',
  styleUrls: ['./popover.component.scss'],
})
export class PopoverComponent implements OnInit {

  profileMenu: any;
  context: any;
  langconext: any;
  role: any;
  clickType: any;


  constructor(public platform: Platform,public api: RestapiService, public actionval: ActionlistenService, public navCtrl: NavController, public cmndeclaration: CommonDeclarationService, public cmndef: CommonDefinitionService) {
    this.platform.ready().then(() => {
      this.role = localStorage.role
      if (this.cmndeclaration.LanguageJson) {
        this.langconext = this.cmndeclaration.LanguageJson.pages[0]['alerts'];
      } else {
        this.cmndeclaration.LanguageJson = JSON.parse(localStorage.languageJson);
        this.langconext = this.cmndeclaration.LanguageJson['pages'][0].alerts;
      }
      if(this.role == "new")
        this.clickType = ""
      else
        this.clickType = "B"
        
      this.cmndeclaration.getstoreProcess("profileMenu").then(data=>{
        this.profileMenu = data;
      });
    });


  }


  ngOnInit() { }

  menuclick(menuData: any) {
    this.api.clickenventcap(menuData.label)
    this.cmndef.popover.dismiss();
    if (menuData.clicktype == '0') {
      sessionStorage.CurrentPage = "/starred"
      this.navCtrl.navigateForward('/starred');
    } else if (menuData.clicktype == '1') {
      this.cmndef.showConfirmAlert("", this.langconext.clearChatHistroyConfirmation, "clearchat", this.langconext.ok, this.langconext.cancel)
    } else if (menuData.clicktype == '2') {
      sessionStorage.CurrentPage = "/va/emailchat"
      this.navCtrl.navigateForward('/va/emailchat');
    } else if (menuData.clicktype == '3') {
        this.cmndeclaration.howtouse = true;
    } else if (menuData.clicktype == '4') {
      this.cmndeclaration.HeaderType = 'search';
      this.cmndeclaration.functionCall = 'search'
    } else if (menuData.clicktype == '5') {
      sessionStorage.CurrentPage = "/about"
      this.navCtrl.navigateForward('/about');
    } 


    }

  }
